import { IDateInputValue } from '../../../ui-toolkit';

export const transformDateInputToValue = (dataValue: IDateInputValue) => dataValue.dateValue || null;
